export default __webpack_public_path__ + "static/media/banner-create-vaga.02b919b8.png";